import { useEffect, useState } from 'react';

// Device type detection logic
function getDeviceType() {
  if (typeof window === 'undefined') return 'desktop'; // Default for SSR
  const ua = navigator.userAgent;
  const width = window.innerWidth;

  // User agent checks for mobile/tablet
  const isMobileUA =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTabletUA =
    /iPad|Tablet|PlayBook|Silk/i.test(ua) ||
    (/(Android)/i.test(ua) && !/Mobile/i.test(ua));

  // Screen size fallback (in case UA is not enough)
  if (
    isTabletUA ||
    (width >= 600 && width <= 1024 && 'ontouchstart' in window)
  ) {
    return 'tablet';
  }

  if (isMobileUA || (width < 600 && 'ontouchstart' in window)) {
    return 'mobile';
  }

  return 'desktop';
}

export function useDeviceType(): 'mobile' | 'tablet' | 'desktop' {
  const [deviceType, setDeviceType] = useState<'mobile' | 'tablet' | 'desktop'>(
    getDeviceType()
  );

  useEffect(() => {
    function handleResize() {
      setDeviceType(getDeviceType());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceType;
}
